import React from 'react';

import { getInitialValueForFormGroup, parseMobileInputDisplay } from './helperFunction';
import MobileInput from './mobileInput';
import MyinfoOtpInput from './myinfoOtpInput';

const MobileFlowControl = ({ keyValue, myinfoData, flowType, ...props }) => {
  // view should be "input" or "otp"
  const [toggleView, setToggleView] = React.useState('input');
  const initialValue = getInitialValueForFormGroup(myinfoData.data, keyValue);
  const removeCountryCode = initialValue.split('+65')[1];
  const parseInitialValue = parseMobileInputDisplay(removeCountryCode);
  const [value, setValue] = React.useState(parseInitialValue);

  return toggleView === 'input' ? (
    <MobileInput
      {...props}
      setToggleView={setToggleView}
      value={value}
      setValue={setValue}
      myinfoData={myinfoData}
      keyValue={keyValue}
      flowType={flowType}
    />
  ) : (
    <MyinfoOtpInput
      {...props}
      setToggleView={setToggleView}
      value={value}
      keyValue={keyValue}
      myinfoData={myinfoData}
      flowType={flowType}
    />
  );
};

export default MobileFlowControl;
